import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import './style.scss';
import appstore from 'assets/imgs/appstore.png';
import ggplay from 'assets/imgs/ggplay.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/fontawesome-free-solid';

const DownloadApp = () => {
  const [isOpen, setOpen] = useState(false);
  let closed = useRef(false);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleScroll = () => {
    const scrollPos = window.pageYOffset;
    if (!closed.current && scrollPos > 500) {
      setOpen(true);
    }
  }

  const handleClose = () => {
    setOpen(false);
    closed.current = true;
  }

  return (
    <div className={`down-app ${!isOpen ? 'hide-box' : ''}`}>
      <div className="down-app__content">
        <h3><FormattedMessage id='IDS_DOWNLOAD_APP' /></h3>
        <a href="https://play.google.com/store/apps/details?id=com.vnp.myvinaphone&hl=vi"
          target="_blank" rel="noopener noreferrer">
          <img alt="app" src={ggplay} />
        </a>
        <a href="https://apps.apple.com/vn/app/my-vnpt/id1017188399?l=vi" className="mt-1"
          target="_blank" rel="noopener noreferrer">
          <img alt="app" src={appstore} />
        </a>
        <FontAwesomeIcon
          color="#C4C4C4"
          icon={faTimes}
          size="lg"
          className="close_btn"
          onClick={handleClose}
        />
      </div>
    </div>
  );
}

export default React.memo(DownloadApp);
